"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col md:flex-row gap-4 items-center">
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-col md:flex-row gap-4 md:gap-6 items-center">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-[13px] md:text-[14px] font-[var(--font-libre-baskerville)] text-[#F5F5DC] hover:bg-[#D4AF37] hover:text-[#002147] transition-colors duration-200 px-3 py-2 rounded-md">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <footer ref={ref} className={`w-full bg-dark-background text-foreground-dark py-8 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col gap-8">
          {}
          <div className="flex flex-col items-center md:items-start text-center md:text-left max-w-2xl mx-auto md:mx-0">
            <h3 className="font-[var(--font-cinzel)] text-[14px] tracking-[2px] uppercase mb-4" style={{
            color: '#F1D592'
          }}>
              THE ARCHITECT
            </h3>
            <p className="text-[14px] font-[var(--font-libre-baskerville)] leading-[1.6] mb-4" style={{
            color: '#F5F5DC'
          }}>As your Legacy Architect, I specialise in distilling a lifetime of experience into the architecture and curation of your family wisdom legacy. My mission is to bridge the gap between fleeting memories and eternal narratives through a bespoke process of anchoring wisdom with precision and love. Together, we ensure your most precious intellectual property is preserved for the generations yet to come.</p>
            <div className="font-['La_Belle_Aurore',_cursive] text-[24px]" style={{
            color: '#D4AF37',
            transform: 'rotate(-2deg)',
            transformOrigin: 'center'
          }}>Ancel Fernandes</div>
          </div>

          {}
          <div className="w-full h-[1px]" style={{
          backgroundColor: 'rgba(212, 175, 55, 0.5)'
        }} />

          {}
          <div className="flex justify-center">
            <MenuProvider menu_id="50">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="hidden items-center gap-4">
            <Link to="https://facebook.com" newTab className="text-foreground-dark/70 hover:text-foreground-dark transition-all duration-300 hover:scale-110" aria-label="Facebook">
              <Facebook className="size-5" />
            </Link>
            <Link to="https://twitter.com" newTab className="text-foreground-dark/70 hover:text-foreground-dark transition-all duration-300 hover:scale-110" aria-label="Twitter">
              <Twitter className="size-5" />
            </Link>
            <Link to="https://instagram.com" newTab className="text-foreground-dark/70 hover:text-foreground-dark transition-all duration-300 hover:scale-110" aria-label="Instagram">
              <Instagram className="size-5" />
            </Link>
            <Link to="https://linkedin.com" newTab className="text-foreground-dark/70 hover:text-foreground-dark transition-all duration-300 hover:scale-110" aria-label="LinkedIn">
              <Linkedin className="size-5" />
            </Link>
          </div>

          {}
          <div className="text-sm text-foreground-dark/70 text-center">
            © 2026 FamilyLegacyVoices. All rights reserved.
          </div>
        </div>

        {}
        <div className="mt-6 pt-4 border-t border-foreground-dark/20">
          <p className="text-center text-[8px] font-[var(--font-montserrat)] text-foreground-dark/60 leading-relaxed max-w-4xl mx-auto">
            Family Legacy Voices is a premier, privacy-first global bespoke practice for Family Wisdom Legacy Architecture & Curation. To ensure narrative precision and absolute data sovereignty, we employ secure, isolated AI environments for synthesis. Upon final delivery, all project data is permanently purged, ensuring your family’s wisdom remains exclusively yours.
          </p>
        </div>
      </div>
    </footer>;
}